export default function getPreviewQueryObject(queryObj) {
  const previewQueryObj = {
    ...queryObj,
    post_status: ['draft', 'pending', 'publish'],
  }
  return previewQueryObj
}
